import { render, staticRenderFns } from "./ServiceLevelRealtime.vue?vue&type=template&id=08ea0c0b&scoped=true"
import script from "./ServiceLevelRealtime.vue?vue&type=script&lang=js"
export * from "./ServiceLevelRealtime.vue?vue&type=script&lang=js"
import style0 from "./ServiceLevelRealtime.vue?vue&type=style&index=0&id=08ea0c0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ea0c0b",
  null
  
)

export default component.exports